
import { Dispatch } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { TableThingyActions } from "../actions/table_actions";
import {userdata} from "../typing/table_typing";
import { myfetchThunk } from "../../../app/myfetch";
import {masteruri} from "../../../config";



interface testdataResponsePayloadInterface{
    data:userdata,
}

export const requestDataFromAPI =() => {
    return (
        dispatch:Dispatch<any>, 
        getState:() => RootState
    )=>{       
        dispatch(myfetchThunk(
            true,
            masteruri+"/Statistics",
            {},
            "GET",
            (payload:testdataResponsePayloadInterface) => {
                console.log(payload);
                dispatch(
                     TableThingyActions.resetData(
                         {
                             data : payload.data,
                         }
                     )
                 );
            },
            ()=>{}
        ) as any)
    }
}